import AccordionItem from './accordion-item.element.js';

export default AccordionItem;

AccordionItem.define('wje-accordion-item', AccordionItem);
